module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('x-table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("员工姓名")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.employeeName))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("工号")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.employeeNo))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("现在职务")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.job))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("入职日期")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.registerTime))])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "detail-page-title",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("变动申请信息")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("变动情况")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.info.auditChoose))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("变动情况说明")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.info.changesDescription))])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "detail-page-title",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("变动前")]), _vm._v(" "), _c('th', {
    staticClass: "detail-page-title",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("变动后")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("部门")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.beforeDepartmentName))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("部门")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.laterDepartmentName))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("职务")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.beforeJob))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("职务")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.laterJob))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("职级")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.beforePositionLevel))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("职级")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.positionLevel))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("工资总额")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.beforeMoney))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("工资总额")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.laterMoney))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("工资调整说明")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.info.wageAdjustment))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("生效日期")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.info.signatureDate))])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-444d28cd","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/detail/todo/hr/personChange.vue
// module id = yGiD
// module chunks = 0